import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { BaseSignalrService } from './base-signalr.service';
import { CacheManagementService } from './cache-management.service';
import { WorkorderStoreService } from './workorder-store.service';
import { AppSettings } from '@core/library/app-settings';
import { MessagingStoreService } from './messaging-store.service';
import { HttpTransportType, HubConnectionBuilder } from '@microsoft/signalr';

@Injectable({
  providedIn: 'root',
})
export class GatewaySignalrService extends BaseSignalrService {
  constructor(
    public apiService: ApiService,
    public woStore: WorkorderStoreService,
    public cacheService: CacheManagementService,
    public messageStore: MessagingStoreService
  ) {
    super(apiService);
  }

  getAuthToken() {
    return this.apiService.getSessionCookie();
  }

  createConnection() {
    this.BaseURL = AppSettings.URL_MNT_Gateway;
    this._hubConnection = new HubConnectionBuilder()
      .withUrl(`${this.BaseURL}MessageHub?SessionId=${this.getAuthToken()}`, {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds: this.reconnectPolicy,
      })
      .build();
  }

  registerUser() {
    const properties = this.cacheService
      .getProperties()
      ?.map((p) => p.PropertyId);
    if (!properties || !properties.length) {
      return;
    }

    this._hubConnection
      .invoke('RegisteredUser', 1, properties)
      .then(() => console.log('WO_User: Registered'))
      .catch((err) => console.error(err));
  }

  onServerEventsRegister() {
    this._hubConnection.on('Staff_Notify', (data: any) => {
      console.log('Staff_Notify', data);
      this.woStore.woUpdated(data);
    });
    this._hubConnection.on('Message_Notify', (data: any) => {
      console.log('Message_Notify', data);
      this.messageStore.incomingMessages(data?.length ? data : [data]);
    });
  }
}
